export enum MYHOUSE_REGISTER_PAGE {
  MAIN = '/myhouse/register/main',
  ADDRESS_SEARCH = '/myhouse/register/address',
  ADDRESS_PYEONG = '/myhouse/register/pyeong',
  COLLECT_TERMS = '/myhouse/terms/collect',
  REGISTER_RESULT = '/myhouse/register/result',
  REGISTER_AUTH = '/myhouse/auth',
}

export enum MYHOUSE_REGISTER_SEARCH_TYPE {
  COMPLEX = 'complex',
  ADDRESS = 'address',
}

export enum MYHOUSE_REGISTER_TERMS {
  COLLECT = 'collect',
}

export enum MYHOUSE_REGISTER_MAIN_INPUT {
  REALESTATE_TYPE = 'realestateType',
  PYEONG = 'pyoneg',
  DEAL = 'deal',
  WARRANTY = 'warranty',
  RENT = 'rent',
  START_DATE = 'date',
  END_DATE = 'endDate',
  NONE = 'none',
}

export enum MYHOUSE_REGISTER_DETAIL_INPUT {
  COMPLEX = 'complex',
  BUILDING = 'building',
  HO = 'ho',
  NONE = 'none',
}

export enum MYHOUSE_REGISTER_SEARCH_PAGE {
  ADDRESS_SEARCH = 'address',
  ADDRESS_DETAIL = 'detail',
  ADDRESS_PYEONG = 'pyeong',
}

export const MYHOUSE_REGISTER_REAL_ESTATE = [
  { text: '아파트', key: 'APART', value: 'A01' },
  { text: '오피스텔', key: 'VILLA', value: 'A02' },
  { text: '빌라/연립', key: 'HOUSE', value: 'C02' },
  { text: '단독/다가구', key: 'STORE_HOUSE', value: 'C03' },
  { text: '상가주택', key: 'BUILDING', value: 'D05' },
  { text: '상가', key: 'BUILDING', value: 'D02' },
  { text: '건물', key: 'BUILDING', value: 'D03' },
]

export enum MYHOUSE_REGISTER_TRADE_TYPE {
  DEAL = 'A1',
  LEASE = 'B1',
  RENT = 'B2',
}

export const MYHOUSE_REGISTER_TRADE_TYPE_INFO = [
  { text: '자가', id: 'DEAL', value: MYHOUSE_REGISTER_TRADE_TYPE.DEAL },
  { text: '전세', id: 'LEASE', value: MYHOUSE_REGISTER_TRADE_TYPE.LEASE },
  { text: '월세', id: 'RENT', value: MYHOUSE_REGISTER_TRADE_TYPE.RENT },
]

export const MYHOUSE_REGISTER_PYEONG_MAXIMUM = 9999
export const MYHOUSE_REGISTER_TRADE_PRICE_MAXIMUM = 9990000
export const MYHOUSE_REGISTER_COMPLEX_NAME_MAXIMUM = 100
export const MYHOUSE_REGISTER_BUILDING_HO_MAXIMUM = 20
export const MYHOUSE_SEARCH_TEXT_EXPOSURE_MAXIMUM = 200

export enum MYHOUSE_AUTHENTICATION_CATEGORY_TYPE {
  OWNER = 'OWNER',
  RESIDENT = 'RESIDENT',
  NONE = '',
}

export enum MYHOUSE_AUTHENTICATION_TYPE {
  CERTIFICATE_OF_REALESTATE_REGISTER = 'CERTIFICATE_OF_REALESTATE_REGISTER',
  PACKAGE = 'PACKAGE',
  MANAGEMENT_FEE = 'MANAGEMENT_FEE',
  NONE = '',
}

export enum MYHOUSE_AUTHENTICATION_PROGRESS {
  INTRO = 'INTRO',
  UPLOAD_CHECK = 'UPLOAD_CHECK',
  TERMS = 'TERMS',
  NONE = '',
}

export const IMAGE_ACCEPT_TYPE = 'image/png, image/jpeg, image/jpg, image/bmp, image/x-ms-bmp'

export const IMAGE_ACCEPT_EXT = 'JPG, JPEG, PNG, BMP'

export const ARTICLE_IMAGE_ACCEPT_TYPE = 'image/png, image/jpeg, image/jpg, image/bmp, image/x-ms-bmp'

export const MYHOUSE_MAX_COUNT = 20
